// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface NavLeftLightIconSignature {
  Element: SVGSVGElement;
}

export const NavLeftLightIcon: TOC<NavLeftLightIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M17.6 1.90001L7.6 11.9L17.7 22L17 22.7L6.2 11.9L16.9 1.20001L17.6 1.90001Z"/>
</svg>
</template>;